import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { cx } from "../internal/cx";
import type { GhostCursorOverlayProps, GhostCursorSpriteState } from "../types";
export function GhostCursorOverlay(t0) {
  const $ = _c(13);
  const {
    avatarAlt: t1,
    avatarSrc,
    state,
    className
  } = t0;
  const avatarAlt = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== avatarAlt || $[1] !== avatarSrc || $[2] !== className) {
    t2 = cursor => <div key={cursor.id} aria-hidden="true" className={cx("vc-ghost-cursor", className)} data-phase={cursor.phase} data-role={cursor.role} style={{
      "--vc-ghost-cursor-duration": `${cursor.durationMs}ms`,
      "--vc-ghost-cursor-fade": `${cursor.fade ?? 1}`,
      "--vc-ghost-cursor-timing": cursor.easing === "expressive" ? "cubic-bezier(0.19, 1, 0.22, 1)" : "cubic-bezier(0.65, 0, 0.35, 1)",
      "--vc-ghost-cursor-x": `${cursor.position.x}px`,
      "--vc-ghost-cursor-y": `${cursor.position.y}px`
    } as CSSProperties}><span className="vc-ghost-cursor__halo" /><span className="vc-ghost-cursor__trail" /><span className="vc-ghost-cursor__pointer"><svg className="vc-ghost-cursor__icon" width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></span>{avatarSrc ? <span className="vc-ghost-cursor__avatar-frame"><img className="vc-ghost-cursor__avatar" src={avatarSrc} alt={avatarAlt} draggable={false} /></span> : null}</div>;
    $[0] = avatarAlt;
    $[1] = avatarSrc;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const renderCursor = t2;
  const visibleMainCursor = state.main.phase === "hidden" ? null : state.main;
  let t3;
  if ($[4] !== renderCursor || $[5] !== visibleMainCursor) {
    t3 = visibleMainCursor ? renderCursor(visibleMainCursor) : null;
    $[4] = renderCursor;
    $[5] = visibleMainCursor;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== renderCursor || $[8] !== state.satellites) {
    t4 = state.satellites.map(renderCursor);
    $[7] = renderCursor;
    $[8] = state.satellites;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}